import { basePath, apiVersion } from "./config";
import {getRefreshTokenApi,getPublicIP,getAccessTokenApi} from "../api/auth";
import {notification,message} from "antd";
import {getContarError} from "./user";

export function get(dir,name,after_dir) {
    const url = `${basePath}/${apiVersion}/${dir}${after_dir}`;
    const refreshToken = getRefreshTokenApi();
    const accessToken = getAccessTokenApi();
    var status;
    var urlFetch='';
    var messag='';
  
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        refreshToken: "Bearer " + refreshToken,
        functionname:name,
        ippublica:getPublicIP()
      },
    };
    // console.log(getPublicIP());
  
    return fetch(url, params)
      .then((response) => {
        status=response.status;
        urlFetch=response.url;
        urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
        return response.json();
      })
      .then((result) => {
        if(status!==200){
            messag=result.message
            notification["error"]({
              message: `Error ${status} in function: ${urlFetch}`,
              description:messag
            });
            getContarError(urlFetch,messag);
          
        }
        return result;
      })
      .catch((err) => {
        return err.message;
      });
  }